import gql from 'graphql-tag';

export default gql`
  query ArtistPagination($page: Int, $limit: Int, $profession: String, $specialty: String) {
    artistPagination(page: $page, limit: $limit, profession: $profession, specialty: $specialty) {
      pages
      currentPage
      count
      artists {
        id
        slug
        name
        lastname
        nationality
        residence
        profession
        specialty
        biography
        enabledStats
        images {
          url
        }
        active
        createdAt
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/ArtistPagination.js